export default __webpack_public_path__ + "static/media/site-logo-white.1d64349b.svg";